
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Es gibt zwar kein Zaubermittel, aber eine Migräne, die sich überhaupt nicht bessern lässt, gibt es auch nicht. Oft werden jedoch die Möglichkeiten nicht ausgeschöpft, zum Beispiel, weil die Medikamente zu niedrig dosiert sind, oder weil ein Medikament weiter genommen wird, obwohl es dem Betroffenen zu wenig hilft. Wirkt beispielsweise die erste Dosis eines Triptans nicht, wird eine zweite Dosis wahrscheinlich auch nichts bringen. Besser ist dann, auf ein anderes Arzneimittel zu wechseln.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;